export const getFCMDevice = () => {
  return localStorage.getItem('fcmDevice');
};

export const setFCMDevice = (device: string) => {
  localStorage.setItem('fcmDevice', device);
};
